import { IDataTableProps } from "./Model";
import TableForLazyLoad from "./TableLazyLoad";
import TablePaging from "./TablePaging";

const Table = (props: IDataTableProps) => {
  return (
    <>
      {props.isLazyLoad ? (
        <TableForLazyLoad {...props} />
      ) : (
        <TablePaging {...props} />
      )}
    </>
  );
};

export default Table;
